<template>
  <div class="shell">
    <!-- Left Sidebar Timeline -->
    <div class="left">
      <div class="left-title">Overview of what to expect in enrolment process</div>
      <div class="timeline">
        <div class="tl-item">
          <div class="tl-spine">
            <div class="tl-dot" :class="timelineSteps[0].status">
              <i class="fa fa-user" aria-hidden="true"></i>
            </div>
            <div class="tl-line" :class="timelineSteps[0].lineStatus"></div>
          </div>
          <div class="tl-body">
            <div class="tl-label" :class="timelineSteps[0].status">Create your own account</div>
            <div class="tl-sub">Identity &amp; access setup</div>
          </div>
        </div>
        <div class="tl-item">
          <div class="tl-spine">
            <div class="tl-dot" :class="timelineSteps[1].status">
              <i class="fa fa-file" aria-hidden="true"></i>
            </div>
            <div class="tl-line" :class="timelineSteps[1].lineStatus"></div>
          </div>
          <div class="tl-body">
            <div class="tl-label" :class="timelineSteps[1].status">Read Consent Document</div>
            <div class="tl-sub">Video + consent document</div>
          </div>
        </div>
        <div class="tl-item">
          <div class="tl-spine">
            <div class="tl-dot" :class="timelineSteps[2].status">
              <i class="fa fa-play" aria-hidden="true"></i>
            </div>
          </div>
          <div class="tl-body">
            <div class="tl-label" :class="timelineSteps[2].status">Consent to take part of the study</div>
            <div class="tl-sub">Acknowledgement + e-signature</div>
          </div>
        </div>
      </div>
      <div class="footnote">
        * It is important to understand that agreeing to participate does not guarantee immediate
        enrollment. Additional screening measures may be implemented subsequent to providing consent.
      </div>
    </div>
 
    <!-- Right Content Panels -->
    <div class="right">
 
      <div v-if="currentStep === 1" class="r-screen">
        <div class="r-title">Create your account</div>
        <div class="r-sub">Creating an account enables you to conveniently view your study details on this platform and
          on any device you use.</div>
          <div class="form-row">
        <div class="fg">
          <label>First name <span>*</span></label>
          <input type="text" :disabled="!hidefields" id="fname" v-model="values.firstName">
        </div>
        <div class="fg">
          <label>Last name <span>*</span></label>
          <input type="text" :disabled="!hidefields" id="lname" v-model="values.lastName">
        </div>
      </div>
       <div class="form-row">
           <div class="fg">
          <label>Username <span>*</span></label>
          <input type="text" :disabled="!hidefields" id="userName" v-model="values.userName">
        </div>
        <div class="fg"><label>Email</label><input :disabled="!hidefields" type="email" v-model="values.emailIdPrimary" readonly></div>
      
       </div>
        <!-- <div class="form-row">
          <div class="fg"><label>Password <span>*</span></label><input type="password" placeholder="••••••••"></div>
          <div class="fg"><label>Confirm password <span>*</span></label><input type="password" placeholder="••••••••">
          </div>
        </div> -->
        <div v-if="hidefields" class="form-row">
    <div class="fg">
      <label>Password <span>*</span></label>
      <div class="position-relative">
        <input :type="inputType" maxlength="20"  v-model="values.password" />
        <i class="password-visible cursor-pointer position-absolute" 
           :class="[visibleOn ? 'fa fa-eye' : 'fa fa-eye-slash']"
           @click.prevent="passwordVisible()"
           style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;">
        </i>
      </div>
      <div class="errormsg" v-if="errors[3] == false">Please enter a password</div>
    </div>
    
    <div class="fg">
      <label>Confirm password <span>*</span></label>
      <div class="position-relative">
        <input :type="inputType" maxlength="20" v-model="newpassword" />
        <i class="password-visible cursor-pointer position-absolute" 
           :class="[visibleOn ? 'fa fa-eye' : 'fa fa-eye-slash']"
           @click.prevent="passwordVisible()"
           style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;">
        </i>
      </div>
      <div class="errormsg" v-if="errors[4] == false">Please enter confirm password</div>
      <span class="errormsg" v-if="errors[5] == false">Password and confirm password mismatch!</span>
    </div>
  </div>
  
  <!-- Password Requirements Error -->
  <span class="errormsg" v-if="errors[6] == false">Passwords must contain at least eight characters, <br />
    including uppercase, lowercase letters, special characters and numbers.</span>
     <div class="form-row">
  <div class="fg">
    <label>Time zone</label>
       <select
                  class="form-select selectforms"
                  valueProp="VisitTypeName"
                  v-model="values.timeZone"
                >
                  <option selected value="">Select time zone</option>
                  <option value="Pacific/Midway">
                    (GMT-11:00) Midway Island, Samoa
                  </option>
                  <option value="America/Adak">
                    (GMT-10:00) Hawaii-Aleutian
                  </option>
                  <option value="Etc/GMT+10">(GMT-10:00) Hawaii</option>
                  <option value="Pacific/Marquesas">
                    (GMT-09:30) Marquesas Islands
                  </option>
                  <option value="Pacific/Gambier">
                    (GMT-09:00) Gambier Islands
                  </option>
                  <option value="America/Anchorage">(GMT-09:00) Alaska</option>
                  <option value="America/Ensenada">
                    (GMT-08:00) Tijuana, Baja California
                  </option>
                  <option value="Etc/GMT+8">
                    (GMT-08:00) Pitcairn Islands
                  </option>
                  <option value="America/Los_Angeles">
                    (GMT-08:00) Pacific Time (US & Canada)
                  </option>
                  <option value="America/Denver">
                    (GMT-07:00) Mountain Time (US & Canada)
                  </option>
                  <option value="America/Chihuahua">
                    (GMT-07:00) Chihuahua, La Paz, Mazatlan
                  </option>
                  <option value="America/Dawson_Creek">
                    (GMT-07:00) Arizona
                  </option>
                  <option value="America/Belize">
                    (GMT-06:00) Saskatchewan, Central America
                  </option>
                  <option value="America/Cancun">
                    (GMT-06:00) Guadalajara, Mexico City, Monterrey
                  </option>
                  <option value="Chile/EasterIsland">
                    (GMT-06:00) Easter Island
                  </option>
                  <option value="America/Chicago">
                    (GMT-06:00) Central Time (US & Canada)
                  </option>
                  <option value="America/New_York">
                    (GMT-05:00) Eastern Time (US & Canada)
                  </option>
                  <option value="America/Havana">(GMT-05:00) Cuba</option>
                  <option value="America/Bogota">
                    (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                  </option>
                  <option value="America/Caracas">(GMT-04:30) Caracas</option>
                  <option value="America/Santiago">(GMT-04:00) Santiago</option>
                  <option value="America/La_Paz">(GMT-04:00) La Paz</option>
                  <option value="Atlantic/Stanley">
                    (GMT-04:00) Faukland Islands
                  </option>
                  <option value="America/Campo_Grande">
                    (GMT-04:00) Brazil
                  </option>
                  <option value="America/Goose_Bay">
                    (GMT-04:00) Atlantic Time (Goose Bay)
                  </option>
                  <option value="America/Glace_Bay">
                    (GMT-04:00) Atlantic Time (Canada)
                  </option>
                  <option value="America/St_Johns">
                    (GMT-03:30) Newfoundland
                  </option>
                  <option value="America/Araguaina">(GMT-03:00) UTC-3</option>
                  <option value="America/Montevideo">
                    (GMT-03:00) Montevideo
                  </option>
                  <option value="America/Miquelon">
                    (GMT-03:00) Miquelon, St. Pierre
                  </option>
                  <option value="America/Godthab">(GMT-03:00) Greenland</option>
                  <option value="America/Argentina/Buenos_Aires">
                    (GMT-03:00) Buenos Aires
                  </option>
                  <option value="America/Sao_Paulo">
                    (GMT-03:00) Brasilia
                  </option>
                  <option value="America/Noronha">
                    (GMT-02:00) Mid-Atlantic
                  </option>
                  <option value="Atlantic/Cape_Verde">
                    (GMT-01:00) Cape Verde Is.
                  </option>
                  <option value="Atlantic/Azores">(GMT-01:00) Azores</option>
                  <option value="Europe/Belfast">
                    (GMT) Greenwich Mean Time : Belfast
                  </option>
                  <option value="Europe/Dublin">
                    (GMT) Greenwich Mean Time : Dublin
                  </option>
                  <option value="Europe/Lisbon">
                    (GMT) Greenwich Mean Time : Lisbon
                  </option>
                  <option value="Europe/London">
                    (GMT) Greenwich Mean Time : London
                  </option>
                  <option value="Africa/Abidjan">
                    (GMT) Monrovia, Reykjavik
                  </option>
                  <option value="Europe/Amsterdam">
                    (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna
                  </option>
                  <option value="Europe/Belgrade">
                    (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana,
                    Prague
                  </option>
                  <option value="Europe/Brussels">
                    (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                  </option>
                  <option value="Africa/Algiers">
                    (GMT+01:00) West Central Africa
                  </option>
                  <option value="Africa/Windhoek">(GMT+01:00) Windhoek</option>
                  <option value="Asia/Beirut">(GMT+02:00) Beirut</option>
                  <option value="Africa/Cairo">(GMT+02:00) Cairo</option>
                  <option value="Asia/Gaza">(GMT+02:00) Gaza</option>
                  <option value="Africa/Blantyre">
                    (GMT+02:00) Harare, Pretoria
                  </option>
                  <option value="Asia/Jerusalem">(GMT+02:00) Jerusalem</option>
                  <option value="Europe/Minsk">(GMT+02:00) Minsk</option>
                  <option value="Asia/Damascus">(GMT+02:00) Syria</option>
                  <option value="Europe/Moscow">
                    (GMT+03:00) Moscow, St. Petersburg, Volgograd
                  </option>
                  <option value="Africa/Addis_Ababa">
                    (GMT+03:00) Nairobi
                  </option>
                  <option value="Asia/Tehran">(GMT+03:30) Tehran</option>
                  <option value="Asia/Dubai">
                    (GMT+04:00) Abu Dhabi, Muscat
                  </option>
                  <option value="Asia/Yerevan">(GMT+04:00) Yerevan</option>
                  <option value="Asia/Kabul">(GMT+04:30) Kabul</option>
                  <option value="Asia/Yekaterinburg">
                    (GMT+05:00) Ekaterinburg
                  </option>
                  <option value="Asia/Tashkent">(GMT+05:00) Tashkent</option>
                  <option value="Asia/Kolkata">
                    (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                  </option>
                  <option value="Asia/Katmandu">(GMT+05:45) Kathmandu</option>
                  <option value="Asia/Dhaka">(GMT+06:00) Astana, Dhaka</option>
                  <option value="Asia/Novosibirsk">
                    (GMT+06:00) Novosibirsk
                  </option>
                  <option value="Asia/Rangoon">
                    (GMT+06:30) Yangon (Rangoon)
                  </option>
                  <option value="Asia/Bangkok">
                    (GMT+07:00) Bangkok, Hanoi, Jakarta
                  </option>
                  <option value="Asia/Krasnoyarsk">
                    (GMT+07:00) Krasnoyarsk
                  </option>
                  <option value="Asia/Hong_Kong">
                    (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                  </option>
                  <option value="Asia/Irkutsk">
                    (GMT+08:00) Irkutsk, Ulaan Bataar
                  </option>
                  <option value="Australia/Perth">(GMT+08:00) Perth</option>
                  <option value="Australia/Eucla">(GMT+08:45) Eucla</option>
                  <option value="Asia/Tokyo">
                    (GMT+09:00) Osaka, Sapporo, Tokyo
                  </option>
                  <option value="Asia/Seoul">(GMT+09:00) Seoul</option>
                  <option value="Asia/Yakutsk">(GMT+09:00) Yakutsk</option>
                  <option value="Australia/Adelaide">
                    (GMT+09:30) Adelaide
                  </option>
                  <option value="Australia/Darwin">(GMT+09:30) Darwin</option>
                  <option value="Australia/Brisbane">
                    (GMT+10:00) Brisbane
                  </option>
                  <option value="Australia/Hobart">(GMT+10:00) Hobart</option>
                  <option value="Asia/Vladivostok">
                    (GMT+10:00) Vladivostok
                  </option>
                  <option value="Australia/Lord_Howe">
                    (GMT+10:30) Lord Howe Island
                  </option>
                  <option value="Etc/GMT-11">
                    (GMT+11:00) Solomon Is., New Caledonia
                  </option>
                  <option value="Asia/Magadan">(GMT+11:00) Magadan</option>
                  <option value="Pacific/Norfolk">
                    (GMT+11:30) Norfolk Island
                  </option>
                  <option value="Asia/Anadyr">
                    (GMT+12:00) Anadyr, Kamchatka
                  </option>
                  <option value="Pacific/Auckland">
                    (GMT+12:00) Auckland, Wellington
                  </option>
                  <option value="Etc/GMT-12">
                    (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                  </option>
                  <option value="Pacific/Chatham">
                    (GMT+12:45) Chatham Islands
                  </option>
                  <option value="Pacific/Tongatapu">
                    (GMT+13:00) Nuku'alofa
                  </option>
                  <option value="Pacific/Kiritimati">
                    (GMT+14:00) Kiritimati
                  </option>
                </select>
  </div>
  <div class="fg">
    <label>Language</label>
     <select
                  class="form-select selectforms"
                  valueProp="VisitTypeName"
                  v-model="values.preferredLanguage"
                >
                  <option selected value="">Select language</option>
                  <option value="AF">Afrikaans</option>
                  <option value="SQ">Albanian</option>
                  <option value="AR">Arabic</option>
                  <option value="HY">Armenian</option>
                  <option value="EU">Basque</option>
                  <option value="BN">Bengali</option>
                  <option value="BG">Bulgarian</option>
                  <option value="CA">Catalan</option>
                  <option value="KM">Cambodian</option>
                  <option value="ZH">Chinese (Mandarin)</option>
                  <option value="HR">Croatian</option>
                  <option value="CS">Czech</option>
                  <option value="DA">Danish</option>
                  <option value="NL">Dutch</option>
                  <option value="EN">English</option>
                  <option value="ET">Estonian</option>
                  <option value="FJ">Fiji</option>
                  <option value="FI">Finnish</option>
                  <option value="FR">French</option>
                  <option value="KA">Georgian</option>
                  <option value="DE">German</option>
                  <option value="EL">Greek</option>
                  <option value="GU">Gujarati</option>
                  <option value="HE">Hebrew</option>
                  <option value="HI">Hindi</option>
                  <option value="HU">Hungarian</option>
                  <option value="IS">Icelandic</option>
                  <option value="ID">Indonesian</option>
                  <option value="GA">Irish</option>
                  <option value="IT">Italian</option>
                  <option value="JA">Japanese</option>
                  <option value="JW">Javanese</option>
                  <option value="KO">Korean</option>
                  <option value="LA">Latin</option>
                  <option value="LV">Latvian</option>
                  <option value="LT">Lithuanian</option>
                  <option value="MK">Macedonian</option>
                  <option value="MS">Malay</option>
                  <option value="ML">Malayalam</option>
                  <option value="MT">Maltese</option>
                  <option value="MI">Maori</option>
                  <option value="MR">Marathi</option>
                  <option value="MN">Mongolian</option>
                  <option value="NE">Nepali</option>
                  <option value="NO">Norwegian</option>
                  <option value="FA">Persian</option>
                  <option value="PL">Polish</option>
                  <option value="PT">Portuguese</option>
                  <option value="PA">Punjabi</option>
                  <option value="QU">Quechua</option>
                  <option value="RO">Romanian</option>
                  <option value="RU">Russian</option>
                  <option value="SM">Samoan</option>
                  <option value="SR">Serbian</option>
                  <option value="SK">Slovak</option>
                  <option value="SL">Slovenian</option>
                  <option value="ES">Spanish</option>
                  <option value="SW">Swahili</option>
                  <option value="SV">Swedish</option>
                  <option value="TA">Tamil</option>
                  <option value="TT">Tatar</option>
                  <option value="TE">Telugu</option>
                  <option value="TH">Thai</option>
                  <option value="BO">Tibetan</option>
                  <option value="TO">Tonga</option>
                  <option value="TR">Turkish</option>
                  <option value="UK">Ukrainian</option>
                  <option value="UR">Urdu</option>
                  <option value="UZ">Uzbek</option>
                  <option value="VI">Vietnamese</option>
                  <option value="CY">Welsh</option>
                  <option value="XH">Xhosa</option>
                </select>
  </div>
</div>
<button class="btn-continue" @click="continueToCreate()" :disabled="accountLoading">
  {{ accountLoading ? 'Creating Account...' : 'Continue' }}
</button>
        <!-- <button class="btn-continue" @click="continueToCreate()">Continue</button> -->
      </div>
 
       <div v-if="currentStep === 2" class="r-screen">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px">
          <!-- <div class="r-title" style="margin-bottom:0">Study materials</div> -->
          <div class="vid-complete-badge" :class="{ show: videoCompleted }"><i class="fa fa-circle-check" aria-hidden="true"></i> Video complete</div>
        </div>
        <div class="tabs">
          <div class="tab d-flex align-items-center" :class="{ active: activeTab === 'doc' }" @click="switchTab('doc')">
            <i class="fa fa-file" aria-hidden="true" style="font-size:12px;margin-right:4px"></i>Consent document
          </div>
          <div v-if="videolist.length > 0" class="tab d-flex align-items-center" :class="{ active: activeTab === 'video' }" @click="switchTab('video')">
            <i class="fa fa-play" aria-hidden="true" style="font-size:12px;margin-right:4px"></i>Video
          </div>
        </div>
      
     <!-- Replace the video tab content with this -->
<div v-if="videolist.length > 0" v-show="activeTab === 'video'">
  <!-- Video List Section -->
  <div class="video-list-container">
    <div 
      v-for="video in videolist" 
      :key="video.id" 
      class="video-list-item"
      @click="playVideo(video)"
    >
      <img src="../../assets/img/icons/watch_overview.png" alt="Video thumbnail" class="video-thumbnail" />
      <div class="video-info">
        <div class="video-title">{{ video.videoTitle || video.videoName }}</div>
        <div class="video-description" v-if="video.videoDescription">{{ video.videoDescription }}</div>
        <div class="video-duration" v-if="video.extention">Duration: {{ video.extention }}</div>
      </div>
      <div class="video-play-icon">
        <i class="fa fa-play-circle" aria-hidden="true"></i>
      </div>
    </div>
  </div>

  <!-- Progress Section (only show if video is playing/has progress) -->
  <div v-if="videoProgress > 0" class="prog-wrap">
    <div class="prog-head">
      <span>Video progress</span>
      <span>{{ videoProgress }}%</span>
    </div>
    <div class="prog-track">
      <div class="prog-fill" :class="{ green: videoCompleted }" :style="{ width: videoProgress + '%' }"></div>
    </div>
  </div>
  
  <div v-if="videoCompleted" style="margin-top:8px">
    <span class="pill-done">
      <i class="fa fa-check-circle" aria-hidden="true"></i> 
      Video completed — you may now review the consent document
    </span>
  </div>
  
  <!-- <div style="margin-top:12px;padding:12px 14px;background:#f8fafc;border-radius:8px;border:0.5px solid #e5e7eb">
    <p style="font-size:12px;font-weight:500;color:#111827;margin-bottom:5px">What this video covers</p>
    <ul style="font-size:11px;color:#6b7280;padding-left:16px;list-style:disc;line-height:1.9">
      <li>Study purpose and background</li>
      <li>What participation involves</li>
      <li>Risks, benefits, and your rights</li>
      <li>How to withdraw at any time</li>
    </ul>
  </div> -->
</div>
        
        <div v-else-if="!isLoading && videolist.length === 0 && activeTab === 'video'" class="text-center" style="padding: 40px;">
          <i class="fa fa-video-camera" style="font-size: 48px; color: #9ca3af;"></i>
          <p style="margin-top: 16px; color: #6b7280;">No videos available for this study.</p>
        </div>
        
        <div v-show="activeTab === 'doc'">
          <div class="doc-frame">
            <div class="doc-toolbar">
                           <span><i class="fa fa-file" aria-hidden="true" style="margin-right:4px"></i>{{ documentName || 'Informed Consent Form' }}</span>
              <!-- <div class="doc-tools">
                <button class="doc-btn"><i class="fa fa-zoom-in" aria-hidden="true"></i>Zoom</button>
                <button class="doc-btn"><i class="fa fa-search" aria-hidden="true"></i>Search</button>
                <button class="doc-btn"><i class="fa fa-download" aria-hidden="true"></i>Save</button>
              </div> -->
            </div>
            <div class="doc-scroll"  @scroll="trackDoc">
                <div v-if="isIcfDocumentLoading" class="document-loader">
                <div class="loader-container">
                  <i class="fa fa-spinner fa-spin loader-icon"></i>
                  <p>Loading document...</p>
                </div>
              </div>
              <div v-else-if="icfDocumentError" class="error-container">
                <i class="fa fa-exclamation-triangle" style="font-size: 32px; color: #dc2626;"></i>
                <p style="color: #dc2626; margin-top: 12px;">{{ icfDocumentError }}</p>
                <button class="retry-btn" @click="retryLoadDocument">Retry</button>
              </div>
              <div v-else-if="selectedIcfDocumentSource">
                <VuePdfEmbed :source="selectedIcfDocumentSource" />
              </div>
              <div v-else class="empty-container">
                <i class="fa fa-file-pdf-o" style="font-size: 48px; color: #9ca3af;"></i>
                <p>No document available</p>
              </div>
            </div>
            <!-- <div class="doc-footer"><span>MedResearch Therapeutics Inc. | IRB Approved | Confidential</span><span>{{ pageIndicator }}</span></div> -->
          </div>
          <div class="prog-wrap">
            <div class="prog-head"><span>Document reviewed</span><span>{{ docProgressValue }}%</span></div>
            <div class="prog-track">
                <div class="prog-fill" :class="{ green: docCompleted }"
                    :style="{ width: docProgressValue + '%' }"></div>
            </div>
          </div>
            <div v-if="docCompleted" style="margin-top:8px">
            <span class="pill-done">
                <i class="fa fa-circle-check"></i>
                Document reviewed
            </span>
            </div>
        </div>
        <div class="btn-row">
          <button class="btn-back" @click="goToStep(1)"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
          <button class="btn-continue" :disabled="!canProceedToStep3"  @click="goToStep(3)">Continue</button>
        </div>
      </div>
 
 <div v-if="currentStep === 3" class="r-screen">
  <!-- Do you consent to take part? -->
  <div style="padding:14px 16px;background:#f8fafc;border-radius:8px;border:0.5px solid #e5e7eb;margin-bottom:20px">
    <p style="font-size:13px;font-weight:500;color:#111827;margin-bottom:12px">
      Do you consent to take part in this study?
    </p>
    <div style="display: flex; gap: 16px;">
      <label class="radio-label d-flex align-items-center">
        <input type="radio" class="me-2" value="yes" v-model="consentAgreed" @change="onConsentChange" />
        <span class="mb-1">Yes, I consent</span>
      </label>
      <label class="radio-label d-flex align-items-center">
        <input type="radio" class="me-2" value="no" v-model="consentAgreed" @change="onConsentChange" />
        <span class="mb-1">No, I do not consent</span>
      </label>
    </div>
  </div>
 
  


 

  <!-- Signing Content - Only show if user clicks Yes -->
  <div v-if="consentAgreed === 'yes'">
    <div style="padding:14px 16px;background:#f8fafc;border-radius:8px;border:0.5px solid #e5e7eb;margin-bottom:16px">
       <div class="r-sub">Please review and confirm the statements below, then sign electronically to complete your enrolment.</div>
      <p style="font-size:12px;font-weight:500;color:#111827;margin-bottom:10px">By signing below, I have confirmed:</p>
      <div class="checks">
        <label class="ck-item">
          <input type="checkbox" v-model="consentChecks.readComprehend"/>
          <span>I acknowledge that I have read and comprehended both the consent form and the study's description.</span>
        </label>
        <label class="ck-item">
          <input type="checkbox" v-model="consentChecks.voluntary">
          <span>I am willingly and voluntarily signing this form as evidence of my decision to participate in this study.</span>
        </label>
        <label class="ck-item">
          <input type="checkbox" v-model="consentChecks.copyReceived">
          <span>I will receive a signed and dated copy of this consent form for my records.</span>
        </label>
        <label class="ck-item" style="margin-bottom:0">
          <input type="checkbox" v-model="consentChecks.healthInfo">
          <span>By signing this form, I provide consent for the use and disclosure of my health information as stated within the form.</span>
        </label>
      </div>
    </div>
      <!-- Consent Confirmation Message -->
  <!-- <div style="padding:16px;background:#f0f9ff;border-left:4px solid #0057D9;border-radius:8px;margin-bottom:20px">
    <p style="font-size:13px;font-weight:500;color:#0057D9;margin-bottom:8px">
      <i class="fa fa-info-circle" aria-hidden="true"></i> Important Notice
    </p>
    <p style="font-size:12px;color:#111827;line-height:1.6">
      By participating in this study, you acknowledge that you have read and understood the study information, 
      and you voluntarily agree to take part. You understand that you can withdraw at any time without affecting 
      your future medical care or benefits to which you are otherwise entitled.
    </p>
  </div> -->
              <div style="padding:16px;background:#f0f9ff;border-left:4px solid #0057D9;border-radius:8px;margin-bottom:4px">
    <p style="font-size:12px;font-weight:600;color:#0057D9;margin-bottom:4px">
      <i class="fa fa-info-circle" aria-hidden="true"></i> Electronic Signature Statement
    </p>
    <p style="font-size:11px;color:#111827;line-height:1.4">
     By entering your registered email address and password below, 
     you acknowledge that your electronic signature is the legally binding equivalent of your handwritten signature in accordance with 21 CFR Part 11. 
     You confirm that you have reviewed the consent information, understand its contents, and voluntarily agree to participate in this study.
    </p>
  </div>
    
    <div style="padding:14px 16px;border:0.5px solid #e5e7eb;border-radius:8px;margin-bottom:16px">
      <p style="font-size:12px;font-weight:500;color:#111827;margin-bottom:12px">e-Signature</p>
      <div class="sig-row">
        <div class="fg">
          <label>Email ID</label>
          <input type="email" v-model="signature.email" id="sigE">
        </div>
        <div class="fg">
          <label>Password</label>
          <input type="password" v-model="signature.password"/>
        </div>
      </div>

    </div>

  </div>

  <!-- Message when user selects No -->
<!-- Message when user selects No -->
<!-- Message when user selects No -->
<div v-if="consentAgreed === 'no'" 
  style="padding:8px 10px;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;margin-bottom:8px"
>
  <p style="font-size:13px;color:#991b1b;margin-bottom:2px">
    Reason <span style="color:#e24b4a;">*</span>
  </p>

  <textarea 
    v-model="signingReason" 
    :disabled="noConsentSubmitted"
    style="width:100%;min-height:80px;padding:8px;border:1px solid #d1d5db;border-radius:6px;font-size:12px;color:#111827"
    :class="{ 'error-border': dissentReasonError }"
    @input="dissentReasonError = false"
  >
  </textarea>

  <!-- Error message -->
  <div v-if="dissentReasonError" style="color:#dc2626; font-size:11px; margin-top:4px;">
    <i class="fa fa-exclamation-circle"></i> Please enter a reason.
  </div>

  <button
    class="save_btn py-1 px-4"
    :disabled="isSubmittingNoConsent"
    @click="submitNoConsent"
  >
    <span
      v-if="isSubmittingNoConsent"
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    {{ $t("navigations.submit") }}
  </button>

  <div v-if="noConsentSubmitted" style="margin-top: 12px; padding: 8px; background-color: #d1fae5; border-radius: 6px; color: #065f46;">
    <i class="fa fa-check-circle" style="margin-right: 6px;"></i>
    Your response has been submitted successfully. Thank you for your consideration.
  </div>
</div>


  <div class="btn-row">
    <button class="btn-back" @click="goToStep(2)">
      <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
    </button>
    <button
  class="save_btn py-1 px-4"
  :disabled="!canSign || isSigning"
  @click="doSign"
>
  <span
    v-if="isSigning"
    class="spinner-border spinner-border-sm me-2"
    role="status"
    aria-hidden="true"
  ></span>
   {{ $t("navigations.sign") }}
</button>
  </div>
</div>
 
      <div v-if="currentStep === 4" class="r-screen">
        <div class="thank-wrap">
          <div
            v-if="alreadySignedFromHistory"
            class="already-signed-alert"
            :class="{ 'already-signed-alert--dissented': consentResponseType === 'dissented' }"
          >
            <div
              class="already-signed-icon"
              :class="{ 'already-signed-icon--dissented': consentResponseType === 'dissented' }"
            >
              <i
                class="fa"
                :class="consentResponseType === 'dissented' ? 'fa-exclamation' : 'fa-info'"
                aria-hidden="true"
              ></i>
            </div>
            <div>
              <p class="already-signed-title">
                {{ consentResponseType === 'dissented' ? 'You have already declined participation in this study' : 'You have already signed the consent.' }}
              </p>
              <p class="already-signed-copy">
                <template v-if="consentResponseType === 'dissented'">
                  Your decision to withdraw consent was recorded<span v-if="consentResponseAtText"> on {{ consentResponseAtText }}</span>.
                  Your response has been saved and the study team has been notified. If you wish to reconsider, please contact the study team directly.
                </template>
                <template v-else>
                  Your e-signature and consent response were successfully recorded<span v-if="consentResponseAtText"> on {{ consentResponseAtText }}</span>.
                  No further action is required from your end at this time.
                </template>
              </p>
            </div>
          </div>
          <div class="thank-card">
            <div
              class="thank-circle"
              :class="{ 'thank-circle--dissented': alreadySignedFromHistory && consentResponseType === 'dissented' }"
            >
              <i class="fa fa-circle-check" aria-hidden="true"></i>
            </div>
            <p class="thank-heading">Thank you for submitting your response!</p>
            <div class="divider-blue"></div>
            <p class="thank-body">We appreciate
              your time and effort in reviewing the study information and submitting your response. Your input is
              invaluable, and we are grateful for your consideration of this research. Should you have any questions or
              need further assistance, please do not hesitate to reach out to us.</p>
            <p class="thank-signoff">Thank you!<br>Sincerely,<br><strong>[Study Team or Organization]</strong></p>
            <button
              type="button"
              class="btn-back thank-review-btn"
              @click="goToStudyDetailsFromSuccess"
            >
              <i class="fa fa-file" aria-hidden="true"></i> Go through the study details
            </button>
          </div>
        </div>
      </div>
 
    </div>
  </div>
  <!-- Modal for Video Playback -->
<teleport to="#app" v-if="showModal">
  <Modal
    @closeModal="showModal = false"
    :videoId="modelvideoId"
    :version="versionId"
    :modalId="Id"
    :modalReferenceId="ReferenceId"
    :modaltype="modalType"
  />
</teleport>
</template>
 
<script src="./eConsent_patient_sign.js"></script>
 
<style scoped>
/* ========== CSS from your design ========== */
:root {
  --color-background-primary: #ffffff;
  --color-background-secondary: #f8fafc;
  --color-text-primary: #111827;
  --color-text-secondary: #6b7280;
  --color-text-tertiary: #9ca3af;
  --color-border-secondary: #d1d5db;
  --color-border-tertiary: #e5e7eb;
  --border-radius-md: 8px;
  --border-radius-lg: 12px;
  --font-sans: 'Inter', sans-serif;
}
* {
  -box-sizing: border-box;
  margin: 0;
  padding: 0;

}

.shell {
  min-height: calc(100vh - 54px); 
  display: flex;
  min-height: 100%;
  background: #e5e7eb;
  overflow: hidden;
  margin: 0px;
  -border: 0.5px solid #e5e7eb;
  min-height: calc(100vh - 54px);
}

.left,
.right {
    min-height: calc(100vh - 54px); 
}
.left {
  width: 30%;
  flex-shrink: 0;
  background: #f8fafc;
  border-right: 0.5px solid #e5e7eb;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
}
.left-title {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 22px;
  letter-spacing: .3px;
}
.timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}
.tl-item {
  display: flex;
  gap: 14px;
  position: relative;
}
.tl-spine {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 28px;
}
.tl-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  flex-shrink: 0;
  transition: all .35s;
  z-index: 1;
}
.tl-dot.active {
  background: #0057D9;
  border-color: #0057D9;
  color: #fff;
}
.tl-dot.done {
  background: #30ad57;
  border-color: #30ad57;
  color: #fff;
}
.tl-line {
  width: 2px;
  flex: 1;
  min-height: 36px;
  background: #e5e7eb;
  transition: background .35s;
  margin: 2px 0;
}
.tl-line.done {
  background: #30ad57;
}
.tl-body {
  padding-bottom: 28px;
  padding-top: 2px;
}
.tl-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  transition: color .35s;
  line-height: 1.4;
}
.tl-label.active {
  color: #0057D9;
}
.tl-label.done {
  color: #30ad57;
}
.tl-sub {
  font-size: 11px;
  color:#9ca3af;
  margin-top: 2px;
  line-height: 1.4;
}
.footnote {
  margin-top: auto;
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.6;
  padding-top: 20px;
  border-top: 0.5px solid #e5e7eb;
}
.right {
  overflow-y: auto;  
  flex: 1;
  min-width: 0;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}
.r-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px 36px;
  min-height: calc(100vh - 4px);
}

.r-title {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}
.r-sub {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 22px;
  line-height: 1.5;
}
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
.form-row .fg {
  flex: 1;
}
.fg {
  margin-bottom: 12px;
}
.fg label {
  display: block;
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
}
.fg label span {
  color: #e24b4a;
}
.fg input, .fg select {
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  border: 0.5px solid #e4e4e4;
  border-radius: 4px;
  background: #ffffff;
  color: #3d3d3d;
  outline: none;
}
.fg input:focus, .fg select:focus {
  border-color: #0057D9;
  box-shadow: 0 0 0 2px rgba(0,87,217,.1);
}
.fg input[readonly] {
  background: #ffffff;
  color: #6b7280;
}
.btn-continue {
  display: block;
  width: 100%;
  padding: 10px;
  background: #0057D9;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
}
.btn-continue:hover:not(:disabled) {
  background: #004bbf;
}
.btn-continue:disabled {
  opacity: .4;
  cursor: default;
}
.btn-back {
  background: none;
  border: 0.5px solid #9ea7b4 !important;
  border-radius: 8px !important;
  padding: 9px 18px;
  font-size: 13px;
  cursor: pointer;
  color: #3b3b3b !important;
}
.btn-back:hover{
  background:#3b3b3b;
  color: #ffffff;
}
.btn-row {
  display: flex;
  gap: 10px;
  margin-top: auto;
  padding-top: 16px;
}
.btn-row .btn-continue {
  margin-top: 0;
  flex: 1;
}
.vid-box {
  background: #111;
  border-radius: 8px;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #e5e7eb;
}
.video-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vid-label {
  margin-top: 10px;
  text-align: center;
}
.play-ring {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,.35);
  background: rgba(255,255,255,.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .2s;
}
.play-ring:hover {
  background: rgba(255,255,255,.2);
}
.play-ring i {
  color: #fff;
  font-size: 20px;
  margin-left: 3px;
}
.vid-label {
  color: rgba(255,255,255,.55);
  font-size: 11px;
  margin-top: 8px;
  text-align: center;
}
.prog-wrap {
  margin-top: 10px;
}
.prog-head {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
}
.prog-track {
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
.prog-fill {
  height: 100%;
  background: #0057D9;
  border-radius: 4px;
  transition: width .4s;
}
.prog-fill.green {
  background: #30ad57;
}
.pill-done {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  background: #EAF3DE;
  color: #27500A;
  font-size: 11px;
  font-weight: 500;
  margin-top: 8px;
}
.tabs {
  display: flex;
  border-bottom: 0.5px solid #e5e7eb;
  margin-bottom: 16px;
}
.tab {
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -0.5px;
}
.tab.active {
  color: #0057D9;
  border-bottom-color: #0057D9;
}
.active {
    opacity: 1;
    pointer-events: auto;
    position: relative;
}
.vid-complete-badge {
  display: none;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #27500A;
  background: #EAF3DE;
  padding: 3px 10px;
  border-radius: 20px;
}
.vid-complete-badge.show {
  display: inline-flex;
}
.doc-frame {
  border: 0.5px solid #e5e7eb;
  border-radius: 8px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.doc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f8fafc;
  border-bottom: 0.5px solid #e5e7eb;
}
.doc-toolbar span {
  font-size: 11px;
  color: #6b7280;
}
.doc-tools {
  display: flex;
  gap: 6px;
}
.doc-btn {
  background: none;
  border: 0.5px solid #d1d5db;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 3px;
}
.doc-scroll {
  max-height: 50vh;
  overflow-y: auto;
  padding: 14px 16px;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.7;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.doc-footer {
  padding: 5px 12px;
  border-top: 0.5px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #9ca3af;
}
.checks {
  margin-bottom: 14px;
}
.ck-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  cursor: pointer;
}
.ck-item input[type=checkbox] {
  margin-top: 2px;
  accent-color: #0057D9;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.sig-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.sig-row .fg {
  flex: 1;
  margin-bottom: 0;
}
.thank-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  text-align: center;
  padding: 10px 20px 20px;
}
.already-signed-alert {
  width: min(100%, 520px);
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
  padding: 14px 16px;
  margin-bottom: 10px;
  background: #ecfdf3;
  border: 1px solid #86d3a0;
  border-radius: 6px;
  color: #065f2b;
}
.already-signed-alert--dissented {
  background: #fff7ed;
  border-color: #fdba74;
  color: #9a3412;
}
.already-signed-icon {
  width: 18px;
  height: 18px;
  border: 1.5px solid #15803d;
  border-radius: 50%;
  color: #15803d;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 10px;
  margin-top: 1px;
}
.already-signed-icon--dissented {
  border-color: #f97316;
  color: #f97316;
}
.already-signed-title {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 700;
  color: #065f2b;
}
.already-signed-copy {
  margin: 0;
  font-size: 11px;
  line-height: 1.5;
  color: #065f2b;
}
.already-signed-alert--dissented .already-signed-title,
.already-signed-alert--dissented .already-signed-copy {
  color: #9a3412;
}
.thank-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #EAF3DE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px auto 20px;
}
.thank-circle i {
  color: #30ad57;
  font-size: 18px;
}
.thank-circle--dissented {
  background: #fff1db;
}
.thank-circle--dissented i {
  color: #ea7a00;
}
.thank-card {
  background: #ffffff;
  border: 1px solid #b8bec7;
  border-radius: 8px;
  padding: 32px 52px 28px;
  max-width: 520px;
  width: 100%;
  min-height: 340px;
}
.thank-heading {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  text-align: center;
}
.thank-body {
  margin: 0 auto;
  max-width: 340px;
  font-size: 12px;
  color: #111827;
  line-height: 1.65;
  text-align: center;
}
.thank-signoff {
  margin-top: 20px;
  font-size: 12px;
  color: #111827;
  line-height: 1.5;
  text-align: center;
}
.thank-review-btn {
  margin-top: 20px;
  width: auto;
  min-width: 230px;
}
.divider-blue {
  width: 80px;
  height: 2px;
  background: #0057D9;
  margin: 10px auto 18px;
}
.thank-title {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  text-align: center;
}
.thank-message {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.7;
  text-align: center;
}
.thank-signature {
  margin-top: 16px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}
.consent-box, .signature-box {
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 0.5px solid #e5e7eb;
  margin-bottom: 16px;
}
.consent-box-title, .signature-box-title {
  font-size: 12px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 10px;
}
.video-info-box {
  margin-top: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 0.5px solid #e5e7eb;
}
.video-info-title {
  font-size: 12px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 5px;
}
.video-info-list {
  font-size: 11px;
  color: #6b7280;
  padding-left: 16px;
  list-style: disc;
  line-height: 1.9;
}
.password-visible {
  right: 20px;
  bottom: 8px;
}
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
}
/* Add these CSS styles */
.video-list-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.video-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 0.5px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.video-list-item:hover {
  background: #f1f5f9;
  border-color: #0057D9;
  transform: translateX(4px);
}

.video-thumbnail {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
}

.video-info {
  flex: 1;
}

.video-title {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}

.video-description {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 2px;
}

.video-duration {
  font-size: 10px;
  color: #9ca3af;
}

.video-play-icon {
  color: #0057D9;
  font-size: 24px;
}

.video-play-icon i {
  transition: transform 0.2s ease;
}

.video-list-item:hover .video-play-icon i {
  transform: scale(1.1);
}

</style>
